var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGitCardBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 289 275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "green-bg_svg__a",
    width: 289,
    height: 275,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121317",
    d: "M0 8a8 8 0 0 1 8-8h273a8 8 0 0 1 8 8v259a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#green-bg_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#green-bg_svg__b)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#green-bg_svg__c)",
    d: "M-52.487-79.138C-8.79-170.74 98.78-210.584 187.775-168.13S313.491-17.002 269.793 74.601s-88.601-8.573-177.596-51.026S-96.185 12.465-52.487-79.138"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#green-bg_svg__d)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#368C7E",
    d: "M416.907 99.128c12.945-54.797-124.651-206.549-237.365-241.855-112.713-35.307-159.34-17.176-172.285 37.621S60.076 43.884 173.024-2.798C285.973-49.481 403.961 153.925 416.907 99.128"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#green-bg_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#42807B",
    d: "M416.911 99.128C429.856 44.331 292.26-107.42 179.546-142.727 66.832-178.034 20.206-159.903 7.261-105.106S60.08 43.884 173.028-2.798C285.977-49.481 403.965 153.925 416.911 99.128"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#green-bg_svg__f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.421,
    cy: 31.83,
    fill: "#489698",
    rx: 98.421,
    ry: 31.83,
    transform: "matrix(.93674 .35003 .2784 -.96047 98.203 -38.557)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "green-bg_svg__h",
    width: 288,
    height: 275,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#green-bg_svg__g)",
    d: "M0 0h288v275H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#green-bg_svg__h)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#green-bg_svg__i)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 188.975,
    cy: -25.243,
    fill: "#446A6D",
    rx: 43.591,
    ry: 137.556,
    transform: "rotate(106.756 188.975 -25.243)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#green-bg_svg__j)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.453,
    cy: -8.657,
    fill: "#F2EFE8",
    rx: 16,
    ry: 69.507,
    transform: "rotate(94.281 204.453 -8.657)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "green-bg_svg__b",
    width: 579.334,
    height: 525.128,
    x: -177.123,
    y: -299.121,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_3869_14244",
    stdDeviation: 57
  })), /*#__PURE__*/React.createElement("filter", {
    id: "green-bg_svg__d",
    width: 560.416,
    height: 417.762,
    x: -68.509,
    y: -235.031,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_3869_14244",
    stdDeviation: 37.075
  })), /*#__PURE__*/React.createElement("filter", {
    id: "green-bg_svg__e",
    width: 560.416,
    height: 417.762,
    x: -68.505,
    y: -235.031,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_3869_14244",
    stdDeviation: 37.075
  })), /*#__PURE__*/React.createElement("filter", {
    id: "green-bg_svg__f",
    width: 308.853,
    height: 215.72,
    x: 44.833,
    y: -142.538,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_3869_14244",
    stdDeviation: 30.9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "green-bg_svg__i",
    width: 408.445,
    height: 258.951,
    x: -15.247,
    y: -154.718,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_3869_14244",
    stdDeviation: 35.95
  })), /*#__PURE__*/React.createElement("filter", {
    id: "green-bg_svg__j",
    width: 187.247,
    height: 82.165,
    x: 110.83,
    y: -49.739,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_3869_14244",
    stdDeviation: 12.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "green-bg_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(121.07 85.335 8.27)scale(195.62 293.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27564E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131619",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "green-bg_svg__g",
    width: 0.417,
    height: 0.436,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#green-bg_svg__k",
    transform: "scale(.00347 .00364)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL0SURBVHgB7drBkYRADEPRzT8DciKn3giGklBzkPu/EzXFzuLDqIzbf3+Yb611/7i+fny+ftyzhOvb/L/ud17C9xxVL4BqD1FwCddu7LiR5UbuJdRyVL0AqoVd6BV8jxtrSoepRPFR9QKo9iIWknhMOtslPHMyxBhZL4BqS3uRV67dztMdMiixdgf3j6wXQLWlvbwncaFEnPsMd/C3R9ULoJrYxSWDBSVS3CjbFYPj6wVQ7UX36B7DuQtsbky5UXxUvQCqiR2ju7GQdJLuhkMSfePrBVBNjIXkKC1ZfnO7Yjeux9cLoJoYTUlH6kaiEmtuN5vMlqvrBVBNjIUtR1fi57vmvUrMjq8XQLWHTk85Mvt69vt1Fz2+XgDVXnSDu47P3KjcNUA4ql4A1R5+8knn6cbdMu93Y80daIypF0C1Zb44h5HodrC7ulZlI2JkvQCqrWyrIbnHjVBlPuzOe8fXC6Dai59/slf8RbTuOv4bWS+Aahtjyh0m7BpKKM//RSxX1Aug2sYuUXnxd+e0bsQl2x0j6wVQTYyI5JhMiTU34pJtiqPqBVBN7PSSo7ckstzIdTvP8fUCqBZ2ocrcNXlhV4YSbhQfVS+Aai9iIYnHpLN158zJUeCYegFUW9qLvHKdbEoke8LJJsb4egFUW/6SmBsXSsS5z3AHf3tUvQCqiV1cMlhQIsWNsl0xOL5eANVedI/uMZy7wObGlBvFR9ULoJrYMbobC0kn6W44JNE3vl4A1cRYSI7SkuU3tyt243p8vQCqidGUdKRuJCqx5nazyWy5ul4A1cRY2HJ0JX6+a96rxOz4egFUe+j0lCOzr2e/X3fR4+sFUO1FN7jr+MyNyl0DhKPqBVDt4SefdJ5u3C3zfjfW3IHGmHoBVFvmi3MYiW4Hu6trVTYiRtYLoNrKthqSe9wIVebD7rx3fL0Aqr34+Sd7xV9E667jv5H1Aqi2MabcYcKuoYTy/F/EckW9AKpt7BKVF393TutGXLLdMbJeDPYPkN6qZhcPlQEAAAAASUVORK5CYII=",
    id: "green-bg_svg__k",
    width: 120,
    height: 120
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitCardBg);
export default __webpack_public_path__ + "static/media/git-card-bg.69c567bb36cb72466cf1989fdbcf1a42.svg";
export { ForwardRef as ReactComponent };